import { DatePicker } from '@mui/lab';
import { TextField } from '@mui/material';
import { isValid } from 'date-fns';
import { useController } from 'react-hook-form';

export function QuoteReminderDate() {
  const name = 'reminderDate';
  const {
    field: { ref, onChange, value, onBlur },
  } = useController({
    name,
    defaultValue: null,
  });
  return (
    <DatePicker
      value={value}
      onChange={onChange}
      renderInput={params => (
        <TextField
          id={name}
          {...params}
          onBlur={onBlur}
          fullWidth
          inputRef={inputRef => {
            if (params.inputRef && typeof params.inputRef === 'function') {
              params.inputRef(inputRef);
            }
            ref(inputRef);
          }}
          label='Reminder Date'
          inputProps={{ ...params.inputProps, 'aria-label': 'Reminder Date' }}
          placeholder='Reminder Date'
          error={Boolean(value) && !isValid(value)}
          helperText={Boolean(value) && !isValid(value) ? 'Reminder date most be valid' : ''}
        />
      )}
      minDate={new Date()}
      mask='__-__-__'
      inputFormat='MM-dd-yy'
    />
  );
}
